import {
  Component,
  HostBinding,
  Input,
  ViewEncapsulation,
} from '@angular/core';

import { VtmnPlayButtonSizeEnum } from './enum/vtmn-play-button-size.enum';
import { VtmnPlayButtonVariantEnum } from './enum/vtmn-play-button-variant.enum';
import { VtmnPlayButtonShapeEnum } from './enum/vtmn-play-button-shape.enum';
import { VtmnPlayButtonVariantStyleEnum } from './enum/vtmn-play-button-variant-style.enum';
import { CtaButtonTypeEnum } from '~/component/call-to-action/enums/button-type.enum';

@Component({
  selector: 'button[app-vtmn-play-button], a[app-vtmn-play-button]',
  templateUrl: './vtmn-play-button.component.html',
  styleUrls: ['./vtmn-play-button.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class VtmnPlayButtonComponent {
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('class') public elementClasses = '';
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('ngClass') public ngClass = '';
  @Input() public size? = VtmnPlayButtonSizeEnum.MEDIUM;
  @Input() public variant? = VtmnPlayButtonVariantEnum.PRIMARY;
  @Input() public style? = VtmnPlayButtonVariantStyleEnum.REGULAR;
  @Input() public shape? = VtmnPlayButtonShapeEnum.ROUNDED;
  @Input() public type? = CtaButtonTypeEnum.Button;
  @Input() public isLoading?: boolean;

  @HostBinding('class')
  public get className(): string {
    const classes = [
      // eslint-disable-next-line max-len
      `${this.elementClasses} ${this.ngClass} vp-button vp-button--${this.size} vp-button--${this.variant} vp-button--${this.style} vp-button--${this.shape}`,
    ];

    return classes.join(' ');
  }
}
